import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ImageUpload.css';

const ImageUpload = ({ onImageUpload, enablePaste = false, targetElementRef = null }) => {
  const [uploading, setUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);

  // 处理粘贴事件
  useEffect(() => {
    if (!enablePaste) return;

    const handlePaste = async (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;

      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.type.indexOf('image') !== -1) {
          e.preventDefault();
          const file = item.getAsFile();
          if (file) {
            await handleFileUpload(file);
          }
          break;
        }
      }
    };

    // 如果指定了目标元素，则在目标元素上监听粘贴事件
    const targetElement = targetElementRef?.current || document;
    targetElement.addEventListener('paste', handlePaste);

    return () => {
      targetElement.removeEventListener('paste', handlePaste);
    };
  }, [enablePaste, targetElementRef, onImageUpload]);

  const handleFileUpload = async (file) => {
    if (!file) return;

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post('/api/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      if (response.data.url) {
        const imageMarkdown = `![${file.name}](${response.data.url})`;
        onImageUpload(imageMarkdown);
      }
    } catch (error) {
      alert('图片上传失败: ' + (error.response?.data?.error || '未知错误'));
    } finally {
      setUploading(false);
    }
  };

  const handleInputChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFileUpload(file);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileUpload(e.dataTransfer.files[0]);
    }
  };

  return (
    <div className="image-upload">
      <div
        className={`upload-area ${dragActive ? 'drag-active' : ''} ${uploading ? 'uploading' : ''}`}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <input
          type="file"
          id="image-upload"
          accept="image/*"
          onChange={handleInputChange}
          disabled={uploading}
          style={{ display: 'none' }}
        />
        <label htmlFor="image-upload" className="upload-label">
          {uploading ? (
            <div className="upload-progress">
              <div className="spinner"></div>
              <span>上传中...</span>
            </div>
          ) : (
            <div className="upload-content">
              <svg t="1751680200710" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4666" width="48" height="48"><path d="M153.6 902.656a32.256 32.256 0 0 1 0-64h716.8a32.256 32.256 0 0 1 0 64z m390.656-665.6v494.592a32.256 32.256 0 0 1-64 0V237.056L236.032 481.28a31.744 31.744 0 1 1-45.056-45.056l294.912-295.424a36.864 36.864 0 0 1 51.2 0l294.912 294.912a31.744 31.744 0 0 1-45.056 45.056z" fill="#5A5A68" p-id="4667"></path></svg>
              <p>点击或拖拽图片到此处上传{enablePaste ? '，或在编辑区域按 Ctrl+V 粘贴图片' : ''}</p>
            </div>
          )}
        </label>
      </div>
    </div>
  );
};

export default ImageUpload;